<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses]">
    <vx-sidebar
        ref="vxSidebar"
        :sidebarItems="sidebarItems"
        :logo="require('@/assets/images/logo/logo.png')"
        :logoMin="require('@/assets/images/logo/logo_min.png')"
        title="E L S  A"
        parent=".layout--main"
        @open-app-settings="openAppSettings"
    />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">

      <div id="content-overlay"></div>

      <div class="content-wrapper" style="min-height: 100vh; display: flex; flex-direction: column;">
<!--        <the-navbar class="xl:hidden" />-->
        <the-header v-if="$route.meta.showHeader !== false" />

        <div class="router-view xl:p-4" style="flex: 1; display: flex; flex-direction: column">
          <div class="router-content xl:mt-0" style="flex: 1; display: flex; flex-direction: column">
            <transition :name="routerTransition">
              <div class="router-header flex flex-wrap items-center mb-6"
                   v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
                <div class="content-area__heading"
                     :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>
              </div>
            </transition>
            <div class="content-area__content" style="flex: 1; display: flex; flex-direction: column">
              <transition :name="routerTransition" mode="out-in">
                <Maintenance v-if="maintenance" />
                <Error404 v-else-if="error404" />
                <Forbidden v-else-if="forbidden" />
                <router-view @changeRouteTitle="changeRouteTitle" />
              </transition>
            </div>
          </div>
        </div>
      </div>

      <AppSettingsPopup ref="appSettingsPopup" />
      <!--      <the-footer></the-footer>-->
    </div>
  </div>
</template>

<script>
import VxSidebar        from '@/layouts/components/vx-sidebar/VxSidebar.vue';
import TheHeader        from "@/layouts/components/TheHeader";
import { mapState }     from "vuex";
// import TheNavbar        from '../components/TheNavbar.vue';
// import TheFooter        from '../components/TheFooter.vue';
import themeConfig      from '@/../themeConfig.js';
import sidebarItems     from "@/layouts/components/vx-sidebar/sidebarItems.js";
import oldColorsMixin   from "../_mixins/oldColorsMixin";
import AppSettingsPopup from "../components/AppSettingsPopup";
import Maintenance      from '@/views/pages/Maintenance.vue';
import Error404         from '@/views/pages/Error404.vue';
import Forbidden        from '@/views/pages/Forbidden';

export default {
  name:       'NoHeader',
  mixins:     [oldColorsMixin],
  data() {
    return {
      CHECK_APP_CONTRAST: true,
      navbarType:         themeConfig.navbarType || 'floating',
      footerType:         themeConfig.footerType || 'static',
      routerTransition:   themeConfig.routerTransition || 'none',
      routeTitle:         this.$route.meta.pageTitle,
      sidebarItems:       sidebarItems,
      windowWidth:        window.innerWidth, //width of windows
    };
  },
  watch:      {
    '$route'() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    selectedHouse: {
      deep: true,
      handler() {
        if (this.$acl.check('isEmployee'))
          this.updateTariffsSidebarItems();
      },
    },
  },
  computed:   {
    ...mapState([
      'maintenance',
      'error404',
      'forbidden',
    ]),
    selectedHouse() {
      if (this.$acl.check('isEmployee')) {
        return this.$store.getters['appUser/selectedHouse'];
      } else {
        return null;
      }
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        'navbar-hidden':   this.navbarType == 'hidden',
        'navbar-sticky':   this.navbarType == 'sticky',
        'navbar-static':   this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      };
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      };
    },
  },
  methods:    {
    openAppSettings() {
      this.$refs.appSettingsPopup.open();
    },
    updateTariffsSidebarItems() {
      if (!this.$acl.check('isEmployee')) return false;


      let sidebarItemIndex = this.sidebarItems.findIndex(item => item.slug === 'tariffs');
      let sidebarItem = this.sidebarItems.find(item => item.slug === 'tariffs');

      if (sidebarItem) {
        let typesIds = this.selectedHouse.available_types;
        let globalTypes = this.$store.getters['appUser/apartmentsTypes'];

        if (typesIds) {
          typesIds = typesIds.split(',');
          let tariffSidebarItem = {
            name:      "Тарифы",
            slug:      "tariffs",
            icon:      "RubleIcon",
            user:      "isEmployee",
            abilities: "rp.tariffs",
          };
          tariffSidebarItem.submenu = [];
          if (typesIds.length > 1) {
            tariffSidebarItem.submenu = [];
            typesIds.forEach(typeId => {
              typeId = Number(typeId);
              let globalType = globalTypes.find(type => type.id === typeId);
              if (globalType) {
                tariffSidebarItem.submenu.push({
                  name:      globalType.name,
                  slug:      "tariffs_" + globalType.id,
                  url:       '/uc/b/tariffs/' + globalType.id,
                  user:      "isEmployee",
                  abilities: "rp.tariffs",
                });
              }
            });
            tariffSidebarItem.submenu.push({
              name:      'Архив',
              slug:      "tariffs_archive" + typesIds[0],
              url:       '/uc/b/tariffs/archive/' + typesIds[0],
              user:      "isEmployee",
              abilities: "rp.tariffs",
            });
            this.sidebarItems[sidebarItemIndex] = tariffSidebarItem;
          } else if (typesIds.length === 1) {
            let globalType = globalTypes.find(type => type.id === Number(typesIds[0]));
            if (globalType) {
              tariffSidebarItem.url = '/uc/b/tariffs/' + globalType.id;
            }
            tariffSidebarItem.submenu.push({
              name:      'Архив',
              slug:      "tariffs_archive" + typesIds[0],
              url:       '/uc/b/tariffs/archive/' + typesIds[0],
              user:      "isEmployee",
              abilities: "rp.tariffs",
            });
            this.sidebarItems[sidebarItemIndex] = tariffSidebarItem;
          }
        } else {
          this.sidebarItems[sidebarItemIndex].url = null;
          delete this.sidebarItems[sidebarItemIndex].submenu;
        }
        this.$refs.vxSidebar.$forceUpdate();
      }
    },
    changeRouteTitle( title ) {
      this.routeTitle = title;
    },
    handleWindowResize( event ) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar');
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch('updateSidebarWidth', 'reduced');
      } else {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
      }
    },
  },
  components: {
    TheHeader,
    VxSidebar,
    // TheNavbar,
    // TheFooter,
    AppSettingsPopup,
    Maintenance,
    Error404,
    Forbidden,

  },
  created() {
    this.setSidebarWidth();
  },
  mounted() {
    if (this.$acl.check('isEmployee')) {
      this.updateTariffsSidebarItems();
    }
  },
  beforeDestroy() {
    this.$store.dispatch('common/tasks/CLEAR_TIMER_UPDATE_UNREAD_MESSAGES');
  },
};
</script>
